import type { Module } from 'vuex';

import {RootState} from "@/store";

export interface AdminOperationState {
  inProgress: boolean;
}

export interface AdminState {
  dataSets: Record<string, {
    index: string | number;
    name: string;
    description: string;
    possibleToDo: boolean;
  }>;
  environment: string | null;
  adminReloadInProgress: boolean;
  reloadImages: AdminOperationState;
  reloadQuantfury: AdminOperationState;
  reloadCoingecko: AdminOperationState;
  reloadCountries: AdminOperationState;
  rebuildLocales: AdminOperationState;
}

const adminModule: Module<AdminState, RootState> = {
  namespaced: true,

  state: (): AdminState => ({
    dataSets: {},
    environment: null,
    adminReloadInProgress: false,
    reloadImages: { inProgress: false },
    reloadQuantfury: { inProgress: false },
    reloadCoingecko: { inProgress: false },
    reloadCountries: { inProgress: false },
    rebuildLocales: { inProgress: false },
  }),

  mutations: {
    setAdminInfo(state, payload) {
      state.dataSets = payload.dataSets;
      state.environment = payload.environment;
      state.adminReloadInProgress = payload.adminReloadInProgress;
      state.reloadImages.inProgress = payload.adminReloadImagesInProgress;
      state.reloadQuantfury.inProgress = payload.adminReloadQuantfuryInProgress;
      state.reloadCoingecko.inProgress = payload.adminReloadCoingeckoInProgress;
      state.reloadCountries.inProgress = payload.adminReloadCountriesInProgress;
      state.rebuildLocales.inProgress = payload.adminRebuildLocalesInProgress;
    },
    setReloadImagesStart(state) {
      state.reloadImages.inProgress = true;
    },
    setReloadImagesFinish(state) {
      state.reloadImages.inProgress = false;
    },
    setReloadQuantfuryStart(state) {
      state.reloadQuantfury.inProgress = true;
    },
    setReloadQuantfuryFinish(state) {
      state.reloadQuantfury.inProgress = false;
    },
    setReloadCoingeckoStart(state) {
      state.reloadCoingecko.inProgress = true;
    },
    setReloadCoingeckoFinish(state) {
      state.reloadCoingecko.inProgress = false;
    },
    setReloadCountriesStart(state) {
      state.reloadCountries.inProgress = true;
    },
    setReloadCountriesFinish(state) {
      state.reloadCountries.inProgress = false;
    },
    setRebuildLocalesStart(state) {
      state.rebuildLocales.inProgress = true;
    },
    setRebuildLocalesFinish(state) {
      state.rebuildLocales.inProgress = false;
    },
  },

  actions: {
    wsAdminInfo({ commit }, payload) {
      commit('setAdminInfo', payload);
    },
    wsAdminReloadImagesStart({ commit }) {
      commit('setReloadImagesStart');
    },
    wsAdminReloadImagesFinish({ commit }) {
      commit('setReloadImagesFinish');
    },
    wsAdminReloadQuantfuryStart({ commit }) {
      commit('setReloadQuantfuryStart');
    },
    wsAdminReloadQuantfuryFinish({ commit }) {
      commit('setReloadQuantfuryFinish');
    },
    wsAdminReloadCoingeckoStart({ commit }) {
      commit('setReloadCoingeckoStart');
    },
    wsAdminReloadCoingeckoFinish({ commit }) {
      commit('setReloadCoingeckoFinish');
    },
    wsAdminReloadCountriesStart({ commit }) {
      commit('setReloadCountriesStart');
    },
    wsAdminReloadCountriesFinish({ commit }) {
      commit('setReloadCountriesFinish');
    },
    wsAdminRebuildLocalesStart({ commit }) {
      commit('setRebuildLocalesStart');
    },
    wsAdminRebuildLocalesFinish({ commit }) {
      commit('setRebuildLocalesFinish');
    },
  },
};

export default adminModule; 